import { render, staticRenderFns } from "./LogOutWarning.vue?vue&type=template&id=0d60a957&"
import script from "./LogOutWarning.vue?vue&type=script&lang=js&"
export * from "./LogOutWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports